












































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { opcaoHabilitadoShared, campoHabilitadoShared, onlyNumber } from '@/utils/common'
import { Hemocomponente } from '@/types/_'

@Component
export default class BackofficReservaHemocomponentes extends Vue {
  $refs!: { reservaHemocomponentes: any }

  reservaHemocomponentesRules: any = {
    valid: true,
    reservaHemocomponentesSimples: [(v: boolean | null) => this.validateReservaHemocomponentesSimples(v)],
    reservaHemocomponentes: [],
    concentradoHemacias: [],
    concentradoPlaquetas: [],
    crioprecipitado: [],
    plasmaFrescoCongelado: [],
    tipagemSanguineaABORHPAI: [],
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getHemocomponentes() {
    return this.getBackofficeGlobalStore.hemocomponentesCheckbox
  }

  set getHemocomponentes(value: string[]) {
    this.getBackofficeGlobalStore.setHemocomponentesCheckbox(value)
  }

  get hemocomponentesLabelUHG() {
    const hospitaisUHG: string[] = ['HOSPITAL ALVORADA MOEMA']
    const hospital = this.getBackofficeGlobalStore.solicitacaoAlterada.hospital
      ? this.getBackofficeGlobalStore.solicitacaoAlterada.hospital.nome.toUpperCase()
      : ''
    return hospitaisUHG.includes(hospital)
      ? 'Quantidade de bolsas *'
      : 'Quantidade *'
  }

  campoHabilitado(prop: string) {
    return campoHabilitadoShared(this.getBackofficeGlobalStore.template, prop)
  }

  opcaoHabilitado(prop1: string, prop2: string) {
    return opcaoHabilitadoShared(this.getBackofficeGlobalStore.template, prop1, prop2)
  }

  campoObrigatorio(campo: string) {
    const formulario = this.getBackofficeGlobalStore &&this.getBackofficeGlobalStore.currentTemplate
      ? this.getBackofficeGlobalStore.currentTemplate.formulario
      : { formulario: {} }

    if (formulario
      && formulario[campo]
      && (formulario[campo].obrigatorio
        || formulario[campo].obrigatorioParaTodosOsConvenios
        || formulario[campo].obrigatorioParaConvenioParticular)
    ) {
      return true
    }
    return false
  }

  onlyNumberUtil(value: any) {
    return onlyNumber(value)
  }

  validateReservaHemocomponentesSimples(value: boolean | null) {
    const obrigatorio = this.campoHabilitado('reservaHemocomponentesSimples') && this.campoObrigatorio('reservaHemocomponentesSimples')
    if (obrigatorio && value === null) return 'Campo obrigatório'
    return false
  }

  validateReservaHemocomponentes() {
    if (this.campoHabilitado('reservaHemocomponentes') && this.campoObrigatorio('reservaHemocomponentes')) {
      this.reservaHemocomponentesRules.reservaHemocomponentes.push((v: any) => (v && v.length > 0) || 'Campo obrigatório')
    }
    return false
  }

  async semReservaHemocomponentes() {
    if (!this.getBackofficeGlobalStore.modal.alterarSolicitacao) return
    const { concentradoHemacias, concentradoPlaquetas, crioprecipitado, plasmaFrescoCongelado, tipagemSanguineaABORHPAI } = this.getBackofficeGlobalStore.solicitacaoAlterada.reservaHemocomponentes

    if (concentradoHemacias.quantidade && concentradoHemacias.quantidade > 0) {
      await this.getBackofficeGlobalStore.deleteReservaHemocomponente('concentradoHemacias')
      this.getBackofficeGlobalStore.clearHemocomponenteField('concentradoHemacias')
    }

    if (concentradoPlaquetas.quantidade && concentradoPlaquetas.quantidade > 0) {
      await this.getBackofficeGlobalStore.deleteReservaHemocomponente('concentradoPlaquetas')
      this.getBackofficeGlobalStore.clearHemocomponenteField('concentradoPlaquetas')
    }

    if (crioprecipitado.quantidade && crioprecipitado.quantidade > 0) {
      await this.getBackofficeGlobalStore.deleteReservaHemocomponente('crioprecipitado')
      this.getBackofficeGlobalStore.clearHemocomponenteField('crioprecipitado')
    }

    if (plasmaFrescoCongelado.quantidade && plasmaFrescoCongelado.quantidade > 0) {
      await this.getBackofficeGlobalStore.deleteReservaHemocomponente('plasmaFrescoCongelado')
      this.getBackofficeGlobalStore.clearHemocomponenteField('plasmaFrescoCongelado')
    }

    if (this.getHemocomponentes.includes('tipagemSanguinea')) {
      await this.getBackofficeGlobalStore.deleteReservaHemocomponente('tipagemSanguinea')
      this.getBackofficeGlobalStore.clearHemocomponenteField('tipagemSanguinea')
    }

    if (tipagemSanguineaABORHPAI.quantidade && tipagemSanguineaABORHPAI.quantidade > 0) {
      await this.getBackofficeGlobalStore.deleteReservaHemocomponente('tipagemSanguineaABORHPAI')
      this.getBackofficeGlobalStore.clearHemocomponenteField('tipagemSanguineaABORHPAI')
    }

    const solicitacaoId = this.getBackofficeGlobalStore.solicitacaoAlterada.id
    const index = this.getHemocomponentes.indexOf('semReserva')

    if (index >= 0) {
      this.getHemocomponentes.splice(0, this.getHemocomponentes.length)
      this.getHemocomponentes.push('semReserva')
      await this.getBackofficeGlobalStore.postReservaHemocomponente({ quantidade: 0, tipo: 'semReserva', solicitacaoId } as Hemocomponente)
    } else {
      this.getHemocomponentes.splice(0, this.getHemocomponentes.length)
      await this.getBackofficeGlobalStore.deleteReservaHemocomponente('semReserva')
    }
  }

  async postHemocomponente(tipo: string) {
    if (!this.getBackofficeGlobalStore.modal.alterarSolicitacao) return
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacaoAlterada.id
    if (this.getBackofficeGlobalStore.solicitacaoAlterada.reservaHemocomponentes) {
      const { quantidade } = this.getBackofficeGlobalStore.solicitacaoAlterada.reservaHemocomponentes[tipo]

      switch (tipo) {
        case 'tipagemSanguinea':
          const request = await this.getBackofficeGlobalStore.deleteReservaHemocomponente(tipo)
          if (request.success) {
            if (this.getHemocomponentes.includes('tipagemSanguinea')) {
              await this.removerSemReservaHemocomponentes()
              await this.getBackofficeGlobalStore.postReservaHemocomponente({ quantidade: 1, tipo, solicitacaoId } as Hemocomponente)
            }
          }
          break
        default:
          if (quantidade > 0) {
            const request = await this.getBackofficeGlobalStore.deleteReservaHemocomponente(tipo)
            if (request.success)await this.getBackofficeGlobalStore.postReservaHemocomponente({ quantidade, tipo, solicitacaoId } as Hemocomponente)
          }
          break
      }
    }
  }

  async reservaHemocomponenteChange(checkbox: string) {
    if (!this.getBackofficeGlobalStore.modal.alterarSolicitacao) return
    if (this.getHemocomponentes.includes(checkbox)) {
      this.reservaHemocomponentesRules[checkbox].push((v: any) => !!v || 'Campo obrigatório.')
    } else {
      if (this.getBackofficeGlobalStore.solicitacaoAlterada.reservaHemocomponentes[checkbox].quantidade > 0) {
        await this.getBackofficeGlobalStore.deleteReservaHemocomponente(checkbox)
      }

      this.reservaHemocomponentesRules[checkbox].splice(0, this.reservaHemocomponentesRules[checkbox].length)
      this.getBackofficeGlobalStore.clearHemocomponenteField(checkbox)
      await this.deleteReservaHemocomponente(checkbox)
    }

    await this.removerSemReservaHemocomponentes()
  }

  async deleteReservaHemocomponente(tipo: string) {
    const { quantidade } = this.getBackofficeGlobalStore.solicitacaoAlterada.reservaHemocomponentes[tipo]
    if (quantidade > 0 || tipo === 'semReserva') await this.getBackofficeGlobalStore.deleteReservaHemocomponente(tipo)
  }

  async removerSemReservaHemocomponentes() {
    const index = this.getHemocomponentes.indexOf('semReserva')
    if (index >= 0) {
      this.getHemocomponentes.splice(index, 1)
      await this.getBackofficeGlobalStore.deleteReservaHemocomponente('semReserva')
    }
  }

  mounted() {
    if (this.getBackofficeGlobalStore.solicitacaoAlterada.reservaHemocomponentes) this.validateReservaHemocomponentes()
  }
}
